namespace Areas.Maintenance.CustomQuery {
    "use strict";

    let customQueryId: number;
    let runQuery: boolean = false;    

    export function getCustomQueryId() {
        return customQueryId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }  
    
    export function onCustomQuerySelected(e: any) {
        var selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            runQuery = true;
            customQueryId = selectedRows[0].customQueryId;
            Areas.refreshGrid("CustomQueryFieldGrid");
            Areas.refreshGrid("CustomQueryLinkGrid");
        }
    }  
    
    export function newCustomQueryField(e: any) {
        const dataGrid = e.component;
        e.data.customQueryId = getCustomQueryId();
    }   
    
    export function newCustomQueryLink(e: any) {
        const dataGrid = e.component;
        e.data.customQueryId = getCustomQueryId();
    } 
    
    var selected: Selected = new Selected();

    export function onUserIDValueChanged(rowData, value) {
        return userValueChanged(selected)(rowData, value);
    }

    export function userLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/Maintenance/CustomQuery/Users", selected)(cellElement, cellInfo);
    }

    export function userLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }    
}